import { Link } from "react-router-dom";

const SALON_UP_LOGO = "https://customer-assets-gfyr7b9c.emergentagent.net/job_beauty-manager-ghl/artifacts/88hjl0ta_Logo%20Salon%20Up%20lungo.PNG";
const MEMENTO_WHITE = "https://customer-assets-gfyr7b9c.emergentagent.net/job_beauty-manager-ghl/artifacts/jdbzjzvz_Logo%20Memento%20White%20lungo.webp";
const MEMENTO_WHITE_SQUARE = "https://customer-assets-gfyr7b9c.emergentagent.net/job_beauty-manager-ghl/artifacts/lfb2s87u_Logo%20Memento%20White.webp";
const MEMENTO_COLOR = "https://customer-assets-gfyr7b9c.emergentagent.net/job_beauty-manager-ghl/artifacts/f8u4hzhv_LOGO_Memento.webp";

export function MementoLogo({ size = "md", withTagline = false, to = "/", variant = "color" }) {
  const sizes = {
    sm: { h: "h-6", tag: "text-[9px]" },
    md: { h: "h-9", tag: "text-[10px]" },
    lg: { h: "h-12", tag: "text-[11px]" },
    xl: { h: "h-16", tag: "text-xs" },
  };
  const s = sizes[size];
  const src = variant === "color" ? MEMENTO_COLOR : MEMENTO_WHITE;

  const inner = (
    <div className="inline-flex flex-col items-start gap-1.5">
      <img src={src} alt="memento" className={`${s.h} object-contain`} draggable={false} />
      {withTagline && (
        <span className={`label-eyebrow ${s.tag}`} style={{ letterSpacing: "0.32em", color: "var(--sp-text-muted)" }}>
          by Salon Up
        </span>
      )}
    </div>
  );

  if (to) return <Link to={to} className="inline-flex items-center">{inner}</Link>;
  return inner;
}

export function SalonUpLogo({ className = "h-7", white = false }) {
  return (
    <img
      src={SALON_UP_LOGO}
      alt="Salon Up"
      className={`${className} object-contain`}
      style={white ? { filter: "brightness(0) invert(1)" } : undefined}
      draggable={false}
    />
  );
}

export { MEMENTO_COLOR, MEMENTO_WHITE, SALON_UP_LOGO };
